


























import { Component, Vue } from 'vue-property-decorator';
import { State, namespace } from 'vuex-class';
import UsersTableBody from '@/views/users/components/UsersTableBody.ts.vue';
import UserInfoForm from '@/views/users/components/UserInfoForm.ts';
import { UserData } from '@/views/users/Users';

const Tenants = namespace('tenants');
const AuthStore = namespace('auth');

@Component({})
export default class UsersList extends Vue {
  private tableBody: unknown = {
    component: UsersTableBody
  }
  
  // @Tenants.State
  private list: ServerList = {};
  
  @Tenants.Action('getUsers')
  private getUsers!: (params?: QueryParams) => Promise<ServerList>
  
  async filter (params?: QueryParams) {
    this.list = await this.getUsers(params);
  }
  
  @AuthStore.State('me')
  private me!: any;
  
  @AuthStore.Getter('userMetaData')
  private userMetaData!: any;
  
  @Tenants.Action('saveUser')
  private saveUser!: (data: UserData) => Promise<UserData>
  
  public onCreateNewUser (): void {
    this.$root.$tcPopup.show({
      title: `New User`,
      component: UserInfoForm
    }).then((form: Vue) => {
      if (form) {
        form.$on('submit', async (data: UserData) => {
          const user = await this.saveUser({
            ...data,
            app_metadata: {
              tenantId: this.me.tenant.id,
              ...(data.app_metadata || {})
            },
            ...(this.userMetaData ? {
              user_metadata: this.userMetaData
            } : {})
          })
          if (user) {
            form.$emit('done');
            console.log(user)
            this.$router.push(`/users/${user.user_id}`)
          }
        })
      }
    })
  }
  
  // private newQuestion!: (obj: { data: Question }) => Question
  async created () {
    // this.list = await this.getUsers();
    // console.log('USERS:CREATED', this.list);
  }
}
